module.exports = __webpack_public_path__ + "static/media/menu_icon.d73e062d.svg";